import { useEffect, useRef, useState } from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { Card } from '../../Card';
import { useUrlParams } from '../../../utils/url';
import { triggerInClientAuth } from '../../../utils/zoomHelper';
import HomeScreen from '../HomeScreen';
import Loading from 'src/components/Loading';

const ZoomRedirect = () => {
  const { org_id: orgId } = useUrlParams();
  const [message, setMessage] = useState<string | null>(null);
  const hasStarted = useRef(false);

  useEffect(() => {
    if (hasStarted.current || !orgId) return;
    hasStarted.current = true;

    const startPatientAuth = async () => {
      if (!orgId) {
        setMessage('Organization not found in URL.');
        return;
      }

      try {
        await triggerInClientAuth(orgId, 'patient');
      } catch (error) {
        setMessage((error as Error).message || 'Unable to sign in with Zoom. Please try again.');
      }
    };

    startPatientAuth();
  }, [orgId]);

  return (
    <HomeScreen content={
      <>
        <h1 className="text-5xl font-bold mb-4">Zoom Redirect</h1>
        <p className="text-xl">
          Zoom will redirect you shortly...
        </p>
      </>
    }>
      <Card className="w-full max-w-md p-8 text-center">
        {message ? (
          <div className="space-y-6">
            <div className="p-4 rounded-lg flex items-start gap-3 bg-red-50 border border-red-200 text-red-800">
              <p className="flex-1 text-left text-sm">{message}</p>
            </div>
            {orgId && (
              <p className="text-center text-sm text-gray-600">
                <a href={`/${orgId}/login`} className="inline-flex items-center justify-center gap-1.5 text-brand-600 hover:underline">
                  Go to Admin Login instead
                  <ArrowRightIcon className="w-4 h-4" />
                </a>
              </p>
            )}
          </div>
        ) : <Loading message="Zoom will redirect you shortly..." />}
      </Card>
    </HomeScreen>
  );
};

export default ZoomRedirect;
